/**
 * Общий список составов паков (WEB-3718, решение владельца 23.10 ~04:35) —
 * СОБРАН по файлам этого каталога сторожем
 * `backend/src/shared/guards/style-pack-composition-files.web3718.spec.ts`,
 * руками не правится. Новый пак — файл `<пак>.ts` рядом и пересборка:
 * `UPDATE_STYLE_PACK_COMPOSITION_INDEX=1 tools/run-tests.sh back <сторож>`.
 */
import type { StylePackComposition, StylePackId } from '../stylePack.types';
import { composition as blueGradient } from './blue-gradient';
import { composition as brightPop } from './bright-pop';
import { composition as cinematicPhoto } from './cinematic-photo';
import { composition as cleanWhite } from './clean-white';
import { composition as darkMystic } from './dark-mystic';
import { composition as editorialSerif } from './editorial-serif';
import { composition as flatSharp } from './flat-sharp';
import { composition as framedCenter } from './framed-center';
import { composition as leftSoft } from './left-soft';
import { composition as monoGlam } from './mono-glam';
import { composition as outlinePills } from './outline-pills';
import { composition as pastelSerif } from './pastel-serif';
import { composition as plainList } from './plain-list';
import { composition as productPremium } from './product-premium';
import { composition as softRounded } from './soft-rounded';
import { composition as stepForm } from './step-form';
import { composition as surveyForm } from './survey-form';
import { composition as techMint } from './tech-mint';
import { composition as warmCream } from './warm-cream';

export const COMPOSITION_FILES: Record<StylePackId, StylePackComposition> = {
  'blue-gradient': blueGradient,
  'bright-pop': brightPop,
  'cinematic-photo': cinematicPhoto,
  'clean-white': cleanWhite,
  'dark-mystic': darkMystic,
  'editorial-serif': editorialSerif,
  'flat-sharp': flatSharp,
  'framed-center': framedCenter,
  'left-soft': leftSoft,
  'mono-glam': monoGlam,
  'outline-pills': outlinePills,
  'pastel-serif': pastelSerif,
  'plain-list': plainList,
  'product-premium': productPremium,
  'soft-rounded': softRounded,
  'step-form': stepForm,
  'survey-form': surveyForm,
  'tech-mint': techMint,
  'warm-cream': warmCream,
};
